// src/locales/en/forms.js
export const forms = {
    emailRequired: "ඊමේල් අවශ්‍යය",
    passwordRequired: "මුරපදය අවශ්‍යය",
    nameRequired: "නම අවශ්‍යය",
    invalidEmail: "කරුණාකර වලංගු ඊමේල් ලිපිනයක් ඇතුළත් කරන්න",
    fieldRequired: "මෙම ක්ෂේත්‍රය අවශ්‍යය",
    savingChanges: "වෙනස්කම් සුරකිමින්...",
    changesSaved: "වෙනස්කම් සාර්ථකව සුරකින ලදී",
    errorSaving: "වෙනස්කම් සුරැකීමේදී දෝෂයක්"
}